import { IModalConfig, ISecret, ISecretPayload, ISecretResponse } from '@mode/notebooks/contract';
import { createAction, props } from '@ngrx/store';

export const loadSecret = createAction('[Notebook Page] LOAD_SECRET');
export const loadSecretSuccess = createAction('[Notebook Page] LOAD_SECRET_SUCCESS', props<ISecretResponse>());
export const loadSecretFail = createAction('[Notebook Page] LOAD_SECRET_FAIL');

export const createSecret = createAction(
  '[Notebook Page] CREATE_SECRET',
  props<{
    payload: ISecretPayload;
  }>()
);
export const createSecretSuccess = createAction('[Notebook Page] CREATE_SECRET_SUCCESS');
export const createSecretFail = createAction('[Notebook Page] CREATE_SECRET_FAIL');

export const editSecret = createAction(
  '[Notebook Page] EDIT_SECRET',
  props<{
    secretId: string;
    payload: ISecretPayload;
  }>()
);
export const editSecretSuccess = createAction('[Notebook Page] EDIT_SECRET_SUCCESS');
export const editSecretFail = createAction('[Notebook Page] EDIT_SECRET_FAIL');

export const deleteSecret = createAction('[Notebook Page] DELETE_SECRET', props<{ secretId: string }>());
export const deleteSecretSuccess = createAction('[Notebook Page] DELETE_SECRET_SUCCESS');
export const deleteSecretFail = createAction('[Notebook Page] DELETE_SECRET_FAIL');

export const openDeleteSecretModal = createAction(
  '[Notebook Page] OPEN_DELETE_SECRET_MODAL',
  props<{ secret: ISecret; modalConfig: IModalConfig; cb: () => void }>()
);
